<template>
  <base-planner
    :api-endpoints="endpoints"
    menu-key="logplanner"
    @showHideLoading="showHideLoading"
  />
</template>

<script>
import MixinMasters from 'src/util/mixinMasters';
import BasePlanner from 'src/views/Pages/Dashboard/Grow/LogPlanner/BasePlanner.vue';

export default {
  name: 'log-planner',
  components: { BasePlanner },
  mixins: [MixinMasters],
  props: {
    showLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      endpoints: {
        inspections: 'grow/logplanner/inspections',
        catchs: 'grow/logplanner/catchs',
        store: 'grow/logplanner/store',
        delete: 'grow/logplanner/delete',
      },
    };
  },
};
</script>
